var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { InfoPerksContext, PerkProgressContext } from '../../../../contexts';
import { PLCCDrawerDesktop, PLCCDrawerMobile, } from '../../../PerksPage/PLCCBanner/PLCCModals';
import { useIsMobile } from '../../../../hooks';
var useGetIsMobile = function () { return useIsMobile().isMobile; };
var useGetPlccData = function () {
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var _a = React.useContext(PerkProgressContext), setPLCCtoggle = _a.setPLCCtoggle, detailsPlcc = _a.detailsPlcc, PLCCtoggle = _a.PLCCtoggle, plccSwitch = _a.plccSwitch;
    return {
        setTogglePLCC: setPLCCtoggle,
        togglePlcc: PLCCtoggle,
        detailsPlcc: detailsPlcc,
        perksInfo: perksInfo,
        plccSwitch: plccSwitch,
    };
};
var ModalMW = function () { return React.createElement(PLCCDrawerMobile, __assign({}, useGetPlccData(), { isMobile: true })); };
var ModalDTW = function () { return React.createElement(PLCCDrawerDesktop, __assign({}, useGetPlccData())); };
export var usePxccDetailsModal = function () {
    var setPLCCtoggle = React.useContext(PerkProgressContext).setPLCCtoggle;
    var PxccDetailsModal = function () {
        return useGetIsMobile() ? React.createElement(ModalMW, null) : React.createElement(ModalDTW, null);
    };
    return { PxccDetailsModal: PxccDetailsModal, setPLCCtoggle: setPLCCtoggle };
};
